(function () {
function csInit() {
document.querySelectorAll('[data-cs-root]').forEach(function (root) {
if (root.dataset.init) return;
root.dataset.init = '1';
var $ = function (s, el) { return (el || root).querySelector(s); };
var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
var slides = $$('[data-slide]'), thumbs = $$('[data-thumb]'), cur = 0;
function show(i) {
  if (!slides.length) return;
  cur = (i + slides.length) % slides.length;
  slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); });
  thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === cur); });
}
thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
if ($('[data-prev]')) $('[data-prev]').addEventListener('click', function () { show(cur - 1); });
if ($('[data-next]')) $('[data-next]').addEventListener('click', function () { show(cur + 1); });
$$('[data-compare]').forEach(function (box) {
  var range = $('input[type=range]', box);
  var set = function () { box.style.setProperty('--pos', range.value + '%'); };
  range.addEventListener('input', set); set();
});
var more = $('[data-more]');
if (more) more.addEventListener('click', function () { $$('.cs-review.is-hidden').forEach(function (r) { r.classList.remove('is-hidden'); }); more.remove(); });
var dataEl = $('[data-product]');
if (!dataEl) return;
var P = JSON.parse(dataEl.textContent);
var tiers = $$('[data-tier]');
var active = tiers[0];
function money(cents) {
  var fmt = P.moneyFormat || ('$' + '{' + '{amount}' + '}');
  var c = Math.round(cents);
  function d(n, p, th, dec) { var x = (n / 100).toFixed(p).split('.'); return x[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (x[1] ? dec + x[1] : ''); }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
    if (k === 'amount_no_decimals') return d(c, 0, ',', '.');
    if (k === 'amount_with_comma_separator') return d(c, 2, '.', ',');
    if (k === 'amount_no_decimals_with_comma_separator') return d(c, 0, '.', ',');
    return d(c, 2, ',', '.');
  });
}
function findVariant(opts) {
  return P.variants.filter(function (v) { return v.options.join('|') === opts.join('|'); })[0];
}
function unitVariant(row) {
  return findVariant($$('select', row).map(function (s) { return s.value; }));
}
function basePrice() { return P.variants.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity); }
function baseCompare(b) { return P.variants.reduce(function (m, v) { return Math.max(m, v.compare > v.price ? v.compare : 0); }, 0) || b; }
function render() {
  var b = basePrice(), cb = baseCompare(b);
  tiers.forEach(function (t) {
    var q = +t.dataset.qty || 1, o = +t.dataset.off || 0;
    var total = b * q * (1 - o / 100), was = cb * q;
    $('[data-tier-price]', t).textContent = money(total);
    var tc = $('[data-tier-compare]', t), ts = $('[data-tier-save]', t);
    if (was > total + 0.5) { tc.textContent = money(was); ts.hidden = false; ts.textContent = 'SAVE ' + Math.round((1 - total / was) * 100) + '%'; }
    else { tc.textContent = ''; ts.hidden = true; }
  });
  var ok = $$('[data-unit]', active).every(function (row) { var v = unitVariant(row); return v && v.available; });
  var atc = $('[data-atc]');
  atc.disabled = !ok;
  atc.textContent = ok ? atc.dataset.label : 'Sold out — pick another size or colour';
  var st = $('[data-stock]');
  if (st) {
    var first = unitVariant($('[data-unit]', active));
    if (first && first.inv !== null && first.inv > 0 && first.inv <= P.lowStock) {
      st.hidden = false;
      $('[data-stock-count]', st).textContent = first.inv;
      $('[data-stock-bar]', st).style.width = Math.max(8, Math.round(first.inv / P.lowStock * 100)) + '%';
    } else st.hidden = true;
  }
}
function pick(t) {
  if (t === active) return;
  tiers.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-checked', x === t); });
  active = t; render();
}
tiers.forEach(function (t) {
  t.addEventListener('click', function (e) { if (!e.target.closest('select')) pick(t); });
  t.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === t) { e.preventDefault(); pick(t); } });
});
$$('[data-unit] select').forEach(function (s) {
  s.addEventListener('change', function () {
    render();
    var row = s.closest('[data-unit]');
    var v = unitVariant(row);
    if (v && v.media) slides.forEach(function (sl, n) { if (+sl.dataset.mediaId === v.media) show(n); });
  });
});
var atcBtn = $('[data-atc]');
atcBtn.dataset.label = atcBtn.textContent.trim();
atcBtn.addEventListener('click', function () {
  var counts = {};
  $$('[data-unit]', active).forEach(function (row) { var v = unitVariant(row); if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
  var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
  var msg = $('[data-msg]'); msg.hidden = true;
  atcBtn.disabled = true; atcBtn.textContent = 'Adding…';
  var r0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(r0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
    .then(function () { window.location.href = r0 + (P.redirect === 'checkout' ? 'checkout' : 'cart'); })
    .catch(function (err) { msg.textContent = err.message; msg.hidden = false; atcBtn.disabled = false; atcBtn.textContent = atcBtn.dataset.label; });
});
render();
});
}
csInit();
document.addEventListener('shopify:section:load', csInit);
})();
